import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useApiClient } from "../../../apiClient";
import { VenueAgentDto } from "../../../models/court-recording/dto/venue-agent.dto";
import { GET_VENUE_AGENTS_QUERY_KEY } from "./useListVenueAgents";

/**
 * "Take a fresh picture of every camera now." Stamps the agent's
 * `snapshotRequestedAt`; the box sees it in its next heartbeat (about a
 * minute) and uploads a new frame per camera, after which each camera's
 * `lastSnapshotAt` moves and the thumbnails reload. Idempotent in effect: a
 * second press moves the stamp, the box dedupes on the value it acted on.
 */
export const useRequestVenueAgentSnapshot = (organizationId: string) => {
    const client = useApiClient();
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (agentId: string) =>
            client.fetchApi<VenueAgentDto, {}>({
                endpoint: `court-recordings/admin/venue-agents/${agentId}/snapshot-request?organizationId=${organizationId}`,
                method: 'POST',
            }),
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: GET_VENUE_AGENTS_QUERY_KEY(organizationId),
            });
        },
    });
};
